module.exports = __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-ae9b3e279d547e10151b58ff7547829e.png";